const data = [
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/1%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/shots/6217503-Charming-Charlie-Mobile',
    id: 'design-portfolio001',
    tags: 'Dribbble',
  },
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/2%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/shots/5816127-Black-Ovis-Homepage-Redesign',
    id: 'design-portfolio002',
    tags: 'Dribbble',
  },
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/3%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/shots/6217484-Charming-Charlie-Homepage-Concept',
    id: 'design-portfolio003',
    tags: 'Dribbble',
  },
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/4%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/shots/6485540-Teahouse-Concept',
    id: 'design-portfolio004',
    tags: 'Dribbble',
  },
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/5%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/shots/6422180-PADI-UI-Concept',
    id: 'design-portfolio005',
    tags: 'Dribbble',
  },
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/6%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/shots/6439262-Watch-Store-UI-Concept',
    id: 'design-portfolio006',
    tags: 'Dribbble',
  },
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/7%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/shots/6377364-Lululemon-Catalog-Concept',
    id: 'design-portfolio007',
    tags: 'Dribbble',
  },
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/8%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/rmgmedia',
    id: 'design-portfolio008',
    tags: 'Dribbble',
  },
  {
    external: true,
    avatar: 'linkedin.jpg',
    color: '#e74281',
    image: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20S.png',
    sources: [
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20XL.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20L.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20M.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20S.png.webp',
        sizes: '',
        type: 'image/webp'
      },
      {
        media: '(min-width: 1600px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20XL.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 1200px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20L.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(min-width: 768px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20M.png',
        sizes: '',
        type: 'image/png'
      },
      {
        media: '(max-width: 767px)',
        srcset: 'https://storage.googleapis.com/qa-rmgmediacom-images/Portfolio/9%20-%20S.png',
        sizes: '',
        type: 'image/png'
      },
    ],
    path: '//dribbble.com/shots/6371630-Lululemon-UI-Concept',
    id: 'design-portfolio009',
    tags: 'Dribbble',
  },
];
  
export default data;
  